<template>
  <c-page>
    <c-content class="hardware-content">
      <c-swipe v-if="banners.length>0" :images="banners" :auto="0" @click="bannerClick"></c-swipe>
      <c-cell-container style="margin: 5px 0" v-if="closeTakeTicket && ticketCount > 0">
        <c-cell :title="'您有%s张购物券可领取'.replace('%s',ticketCount)"
                :icon="require('@/assets/images/hardware-market/clip-8@2x.png')" :theme-name="cellThemeName"
                @click.native="goodsTicket"
        ></c-cell>
      </c-cell-container>
      <c-thum :items="goodsItem" @click="goodsItemClick">
        <template slot="item" scope="props">
          <div class="thum-title">{{ props.obj.title }}</div>
          <div class="thum-price">{{ props.obj.price | currency0}}</div>
        </template>
      </c-thum>
    </c-content>
    <!--<c-footer></c-footer>-->
  </c-page>
</template>
<style lang="scss" scoped>
  @import "./index";
  @import "../../../assets/scss/base/__variables";
  
  .hardware-content {
    background-color: $c-thum-bg-color;
  }
</style>
<script>
  import Hardware from '../../../model/hardware-market'
  import IOSAvoidReview from '@/mixins/ios-avoid-review'

  export default {
    data () {
      return {
        closeTakeTicket: false,
        hardware: new Hardware(),
        banners: [],
        bannersArr: [],
        goodsItem: [],
        cellThemeName: 'theme-haraware-market'
      }
    },
    mixins: [IOSAvoidReview],
    components: {},
    created () {
    },
    async mounted () {
      const isAvoid = await this.$_IOSAvoidReviewMixins_isAvoidReview()
      const data = await this.hardware.loadData()
      if (!isAvoid) {
        this.bannersArr = data.banners
        for (let item of data.banners) {
          this.banners.push(item.image)
        }
      }
      this.goodsItem = data.goodsItem
    },
    beforeDestroy () {
    },
    methods: {
      goodsItemClick (itemObj) {
        this.$router.push({name: 'hardwareDetail', params: {id: itemObj.goodsId}})
      },
      goodsTicket () {
        this.$router.push({name: 'goodsTicket'})
      },
      bannerClick (index) {
        let bannerItem = this.bannersArr[index]
        let url = bannerItem.link.url || ''
        if (!url) return
        if (/http|https/.test(url)) {
          this.$store.dispatch('setInnerWebView', url)
          this.$router.push({path: '/innerwebview'})
        } else {
          let tabs = ['senior', 'value-added-service', 'hardware-market', 'all-version', 'realsale20180518']
          if (tabs.includes(url)) {
            this.$bus.$emit('openTab', url) // 打开指定tab
            return
          }
          this.$router.push({path: url})
        }
      }
    },
    computed: {
      ticketCount () {
        return this.$store.getters.getTicketCount
      }
    },
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?4bbdcd4e